export default __webpack_public_path__ + "static/media/maya_coming_soon.0c1abfab.png";